import { Action, createReducer, on } from '@ngrx/store';
import {
  AccountCheck,
  Country,
  IBillingSettings,
  IUserAccess,
  Language,
  Meeting,
  Subject,
  SubjectsRegistry,
} from 'lingo2-models';
import { AppState } from '..';
import {
  clearData,
  loadAccountCheckSuccess,
  loadAllLanguagesSuccess,
  loadBillingSettingSuccess,
  loadCountriesSuccess,
  loadFilteredLanguagesSuccess,
  loadProfileSettingSuccess,
  loadSubjectSuccess,
  loadSubjectsV2Success,
} from '../actions/data.actions';

export interface State {
  accountCheck: Partial<AccountCheck>;
  countries: Country[];
  languages: {
    all: Language[];
    filtered: Language[];
  };
  profileSettings: Partial<IUserAccess>;
  billingSettings: Partial<IBillingSettings>;
  subjects: Subject[];
  subjectsV2: SubjectsRegistry;
}

const initialState: State = {
  accountCheck: {},
  countries: [],
  languages: {
    all: [],
    filtered: [],
  },
  profileSettings: {},
  billingSettings: {},
  subjects: [],
  subjectsV2: {
    other: [],
    user: [],
    native: [],
    foreign: [],
    non_categorized: [],
    recent: [],
  },
};

const dataReducer = createReducer(
  initialState,
  on(clearData, () => ({ ...initialState })),
  on(loadAccountCheckSuccess, (state, { accountCheckData }) => ({
    ...state,
    accountCheck: accountCheckData,
  })),
  on(loadCountriesSuccess, (state, { countries }) => ({
    ...state,
    countries,
  })),
  on(loadAllLanguagesSuccess, (state, { languages }) => ({
    ...state,
    languages: {
      ...state.languages,
      all: languages,
    },
  })),
  on(loadFilteredLanguagesSuccess, (state, { languages }) => ({
    ...state,
    languages: {
      ...state.languages,
      filtered: languages,
    },
  })),
  on(loadProfileSettingSuccess, (state, { settings }) => ({
    ...state,
    profileSettings: settings,
  })),
  on(loadBillingSettingSuccess, (state, { settings }) => ({
    ...state,
    billingSettings: settings,
  })),
  on(loadSubjectSuccess, (state, { subjects }) => ({
    ...state,
    subjects,
  })),
  on(loadSubjectsV2Success, (state, { subjectsV2 }) => ({
    ...state,
    subjectsV2,
  })),
);

export function reducer(state: State | undefined, action: Action) {
  return dataReducer(state, action);
}

const thisFeatureKey = 'data';
export const dataFeatureKey = thisFeatureKey;

const getThisState = (state: AppState) => state[thisFeatureKey];

export const getAccountCheck = (state: AppState) => state[thisFeatureKey].accountCheck;

export const getCountries = (state: AppState) => state[thisFeatureKey].countries;

export const getLanguages = (state: AppState) => state[thisFeatureKey].languages;

export const getProfileSettings = (state: AppState) => state[thisFeatureKey].profileSettings;

export const getBillingSettings = (state: AppState) => state[thisFeatureKey].billingSettings;

export const getSubjects = (state: AppState) => state[thisFeatureKey].subjects;

export const getSubjectsV2 = (state: AppState) => state[thisFeatureKey].subjectsV2;
